import Field, { Input } from "../../ui/Field";
import PhoneInput from "../../ui/PhoneInput";
import a from "./auth.module.css";

export default function AuthField({
  label,
  hint,
  type = "text",
  value,
  onChange,
  onBlur,
  placeholder,
  name,
  autoComplete,
  required,
  minLength,
  asPhone = false,
  inputMode,
  inputClassName = "",
}) {
  const inputCls = `${a.authInput} ${inputClassName}`.trim();
  return (
    <Field label={label} hint={hint}>
      {asPhone ? (
        <PhoneInput
          className={inputCls}
          name={name}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          placeholder={placeholder}
          required={required}
        />
      ) : (
        <Input
          className={inputCls}
          type={type}
          name={name}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          placeholder={placeholder}
          autoComplete={autoComplete}
          inputMode={inputMode}
          required={required}
          minLength={minLength}
        />
      )}
    </Field>
  );
}
